import Vue from 'vue'
import Vuetify from 'vuetify'
import { mapMutations } from 'vuex'
import VuetifyConfirm from 'vuetify-confirm'
import VueLogger from 'vuejs-logger'
import Vue2Filters from 'vue2-filters'
import Draggable from 'vuedraggable'

import App from '@/App'
import Validation from '@/validation'
import Pusher from '@/pusher'

import store from '@/store'
import router from '@/router'
import vuetifyLocale from '@/locales/vuetify'
import emitter from '@/emitter'

import '@/filters'
import '@/directives'
import '@/components/shared'
import { userRoles } from '@/enums/user-roles'

import '@/assets/app.scss'
import 'vuetify/dist/vuetify.min.css'

import VueInteractJs from 'vue-interactjs'
Vue.use(VueInteractJs)

Vue.config.productionTip = false
Vue.prototype.$config = require('@/config').default

let isDevelopment = process.env.NODE_ENV !== 'production'

Vue.component('draggable', Draggable)

Vue.use(Vuetify, {
  theme: {
    primary: '#27ae60',
    accent: '#eb8d8d'
  },
  lang: {
    current: 'ru',
    locales: vuetifyLocale
  }
})

Vue.use(Vue2Filters)
Vue.use(Validation)

Vue.use(VuetifyConfirm, {
  buttonTrueText: 'OK',
  buttonFalseText: 'Отмена'
})

Vue.use(VueLogger, {
  isEnabled: isDevelopment,
  showLogLevel: true,
  showMethodName: true,
  showConsoleColors: true
})

// Создадим объект таймера
// let timer = new Worker('/timer-worker.js')
// timer.onmessage = ({ data }) => {
//   if (data) {
//     store.dispatch('auth/refreshToken')
//   }
// }
// Обновляем токен 1 раз в 10 минут
// timer.postMessage({
//   command: 'start',
//   interval: 60 * 10
// })

let { user, token } = store.state.auth
if (null !== user && null !== token) {
  // При инициализации засетим из стора
  Vue.$user.set(user)
  store.commit('auth/setToken', token)

  // Проверим пользователя на сервере и запустим Pusher
  invalidateUser().then(() => {
    createPusher(token)
    subscribeToPusher()
  })
}

// Состояние авторизации
store.watch(
  () => store.state.auth.token,
  token => {
    if (void 0 === Vue.prototype.$pusher) return
    Vue.prototype.$pusher.echo.connector.options.auth.headers['Authorization'] =
      'Bearer ' + token
    Vue.$log.debug('Echo token updated')
  }
)
// Состояние авторизации
store.watch(
  () => store.getters['auth/authenticated'],
  authenticated => {
    if (authenticated) {
      let defRouteName = 'Index'

      let { user, token } = store.state.auth
      Vue.$user.set(user)

      createPusher(token)
      subscribeToPusher()

      // Для клиентов будем открывать "Список Договоров"
      if (Vue.$user.hasRoles([userRoles.Client])) {
        defRouteName = 'Client.Deals'
      }

      router.push({ name: defRouteName })
    } else {
      Vue.$user.unset()

      // Отпишемся от событий Pusher
      if (void 0 !== Vue.prototype.$pusher) {
        Vue.prototype.$pusher.echo.leave('admin')
      }

      router.push({ name: 'Auth.Login' })
    }
  }
)

// Pusher событий
function createPusher(token) {
  Vue.prototype.$pusher = new Pusher(token)
  Vue.prototype.$pusher.start()
}

// Подписка на Pusher
function subscribeToPusher() {
  Vue.prototype.$pusher.echo
    .private('admin')
    .listen('.roles.remove', ({ data }) => {
      if (user.id === +data) {
        invalidateUser()
      }
    })
    .listen('.roles.insert', ({ data }) => {
      if (user.id === +data.user_id) {
        invalidateUser()
      }
    })

  // Глобальная подписка на сервис пушера
  let subscription = Vue.prototype.$pusher.subscription
  subscription.bind_global((event, { data }) => {
    emitter.$emit(event, data)
  })
}

// Валидация состояния авторизации пользователя
function invalidateUser() {
  return store.dispatch('auth/invalidateUser').then(user => {
    Vue.$user.set(user)
    if (!Vue.$user.hasAccess(router.history.current)) {
      router.push({ name: '403' })
    }
  })
}

// Рендерим приложение
new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App),
  methods: {
    showSnack(message, error) {
      if (error) this.$log.error(error)
      this.showSnackbar(message)
    },
    ...mapMutations({ showSnackbar: 'app/showSnack' }),
    ...mapMutations('auth', ['setClient', 'setManager'])
  }
})
